export default "__VITE_ASSET__3fbf2860__"